import { useEffect, useMemo, useState } from "react";
import { TiPencil } from "react-icons/ti";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import AddUser from "./components/AddUser";
import { appApis, headerColumn } from "../../constants";
import { useApiRequest } from "../../hooks/useApiRequest";
import ToggleSwitch from "../../Common/Checkbox";
import { formatDate } from "../../utils";
import ResetPassword from "./components/ResetPassword";
import { MdLockReset } from "react-icons/md";

const Users = () => {
    const [state, setState] = useState({
        addUser: false,
        resetPassword: false,
        search: "",
        users: [],
        userData: {}
    });
    const { addUser, search, users, userData, resetPassword } = state;
    const { request: getRequest, loading } = useApiRequest();
    const { request: submitRequest } = useApiRequest();

    const filteredData = useMemo(() => {
        return search ? users?.filter((user) => {
            const searchLower = search.toLowerCase();
            return (user.name?.toLowerCase().includes(searchLower) ||
                user.mobileNo?.toLowerCase().includes(searchLower))
        }) : users;
    }, [search, users]);

    const getInstData = () => {
        getRequest({
            url: appApis.getUsers,
            showToast: false,
            onSuccess: (data) => {
                if(data) setState(prev => ({ ...prev, users: data?.data?.users ?? [] }));
            }
        })
    }

    const changeInstallerStatus = (status, id) => {
        submitRequest({
            url: `${appApis.getUsers}/${id}/status`,
            method: "PATCH",
            body: { status },
            onSuccess: getInstData
        })
    }

    useEffect(() => {
        getInstData();
    }, [])

    return (
        <div className="user-container">
          <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} />
          <TableComponent title={"User Management"} col={3} headers={headerColumn.users} data={filteredData} tableLoading={loading} 
          render={(tdData, index) => <tr key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.name ?? "-"}</td>
            <td>{tdData?.email ?? "-"}</td>
            <td>{tdData?.mobileNo ?? "-"}</td>
            <td>{tdData?.Roles?.[0]?.roleName ?? "-"}</td>
            <td>
                <div className={`d-flex justify-content-center align-items-center px-3`}>
                    <ToggleSwitch
                        value={(tdData?.status ?? "active") == "active" ? true : false}
                        onChange={() => changeInstallerStatus((tdData?.status ?? "active") == "active" ? "inactive" : "active", tdData?.userId)}
                    />
                </div>
            </td>
            <td>{formatDate(tdData?.createdAt ?? "")}</td>
            <td>
                <div className="action d-flex justify-content-center align-items-center px-3">
                    <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => setState(prev => ({ ...prev, addUser: true, userData: tdData }))} variant="btn-outline-edit" />
                    <ButtonElement text={<MdLockReset size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => setState(prev => ({ ...prev, resetPassword: true, userData: tdData }))} variant="btn-outline-blue" />
                </div>
            </td>
        </tr>} FilterComponent={
            <div className="d-flex justify-content-end">
                <ButtonElement text={"Add User"} cssClass="small-radius ms-2 mb-1" onClick={() => setState(prev => ({ ...prev, addUser: true, userData: {} }))} variant="btn-black" />
            </div>} />
          {addUser ? <AddUser show={addUser} hideModal={() => setState(prev => ({ ...prev, addUser: false, userData: {} }))} userData={userData} getInstData={getInstData} /> : null}
          {resetPassword ? <ResetPassword show={resetPassword} hideModal={() => setState(prev => ({...prev, resetPassword: false, userData: {} }))} userData={userData} /> : null}
        </div>
      );
}

export default Users;